module.exports = {
	'/search': '/api/search',
	'/page/search': '/api/search',
	'/page/searchLanding': '/api/search/landing',
	'/page/storageDealsLanding': '/api/search/landing',
};
